import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { opcInfoAtom } from '../atoms/opcInfoAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import type { YearlyMileagesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';

export const getCarYearlyMileagesWithSuggestionSelector = selector<YearlyMileagesDTO>({
    key: 'getCarYearlyMileagesWithSuggestionSelector',
    get: async ({ get }) => {
        const { coverableId } = get(opcInfoAtom);
        const { jobNumber, sessionId } = get(jobInfoAtom);
        return await OnlineSales.getCarYearlyMileagesWithSuggestion(
            jobNumber,
            sessionId,
            coverableId
        );
    }
});
